/** In-app chat page (v1 messagesView, made functional). All conversations across
 * your wholesale deals — team chat + logged calls/texts/emails — in one place,
 * with All / @Mentions tabs and search. Clicking a message jumps to its deal. */
import { useMemo, useState } from "react";
import type { WholesaleDeal } from "../wholesale/api";
import { aggregateMessages, filterMessages, messageEmoji } from "./api";

export function MessagesPage({
  wholesale,
  onOpenDeal,
}: {
  wholesale: WholesaleDeal[];
  onOpenDeal: (natKey: string) => void;
}) {
  const [tab, setTab] = useState<"all" | "mentions">("all");
  const [q, setQ] = useState("");

  const all = useMemo(() => aggregateMessages(wholesale), [wholesale]);
  const shown = useMemo(() => filterMessages(all, tab, q), [all, tab, q]);
  const mentionCount = useMemo(() => all.filter((e) => e.mentions).length, [all]);

  return (
    <div className="leads msgspage">
      <div className="exphead">
        <h1>In-app chat</h1>
      </div>
      <div className="expqbo">All conversations across your wholesale deals — team chat plus logged calls, texts, and emails.</div>

      <div className="msgtabs">
        <button className={"msgtab" + (tab === "all" ? " on" : "")} onClick={() => setTab("all")}>💬 All messages <span className="msgtabn">{all.length}</span></button>
        <button className={"msgtab" + (tab === "mentions" ? " on" : "")} onClick={() => setTab("mentions")}>@ Mentions <span className="msgtabn">{mentionCount}</span></button>
      </div>

      <div className="msgsearch">
        <input placeholder="Search messages, deals, people…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>

      <div className="msglist">
        {shown.length === 0 ? (
          <div className="expempty">
            {all.length === 0
              ? "No messages yet — team chat and logged calls/texts on your wholesale deals show up here."
              : "No messages match."}
          </div>
        ) : (
          shown.map((e) => (
            <button key={e.key} className="msgrow" onClick={() => onOpenDeal(e.natKey)}>
              <span className="msgemoji">{messageEmoji(e.kind)}</span>
              <span className="msgmain">
                <span className="msgaddr">🏠 {e.address}</span>
                <span className="msgtext"><strong>{e.sender}:</strong> {e.text}</span>
              </span>
              <span className="msgpill">{e.kind === "chat" ? "Team" : e.kind}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
